import { useState } from 'react'

// Define a generic function to create state and initial constant
export function useGenericFormState<T>(
  initialValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>, T] {
  const [state, setState] = useState<T>(initialValue)
  const initialConstant = initialValue
  return [state, setState, initialConstant]
}

// Define a generic function to check if the initial value equals the current state
export function isInitialState<T>(initialValue: T, currentState: T): boolean {
  return JSON.stringify(initialValue) === JSON.stringify(currentState)
}
